import axios from 'axios' // 引入axios
import { ElMessage, ElMessageBox } from 'element-plus'
import { emitter } from '@/utils/bus.js'
import {apiURL} from "@/config/settings";

const service = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? '' : apiURL,
    timeout: 99999
})
let acitveAxios = 0
let timer
const showLoading = () => {
    acitveAxios++
    if (timer) {
        clearTimeout(timer)
    }
    timer = setTimeout(() => {
        if (acitveAxios > 0) {
            emitter.emit('showLoading')
        }
    }, 400)
}

const closeLoading = () => {
        acitveAxios--
        if (acitveAxios <= 0) {
            clearTimeout(timer)
            emitter.emit('closeLoading')
        }
    }
    // http request 拦截器
service.interceptors.request.use(
    config => {
        if (!config.donNotShowLoading) {
            showLoading()
        }
        config.data = JSON.stringify(config.data)
        config.headers = {
            'Content-Type': 'application/json'
        }
        return config
    },
    error => {
        closeLoading()
        ElMessage({
            showClose: true,
            message: error,
            type: 'error'
        })
        return error
    }
)

// http response 拦截器
service.interceptors.response.use(
    response => {
        closeLoading()
        if (response.data.code === 0 || response.headers.success === 'true') {
            if (response.headers.msg) {
                response.data.msg = decodeURI(response.headers.msg)
            }
            return response.data
        } else {
            ElMessage({
                showClose: true,
                message: response.data.msg,
                type: 'error'
            })
            return response.data.msg ? response.data : response
        }
    },
    error => {
        closeLoading()
        if (!error.response) {
            ElMessage({
                showClose: true,
                message: 'Network Error: ' + error.message,
                type: 'error'
            })
            return Promise.reject(error)
        }
        switch (error.response.status) {
            case 500:
    ElMessageBox.confirm(`
        <p>Detected API error: ${error}</p>
        <p>Error code <span style="color:red">500</span>: Internal Server Error. Please contact jorin@mcneel.com</p>
    `, 'API Error', {
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: true,
        confirmButtonText: 'Clear Cache',
        cancelButtonText: 'Cancel'
    })
    break;
case 404:
    ElMessageBox.confirm(`
        <p>Error code <span style="color:red">404</span>: Page not found. Please contact jorin@mcneel.com</p>
    `, 'Page not found', {
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: true,
        confirmButtonText: 'Got it',
        cancelButtonText: 'Cancel'
    })
    break;

        }

        return error
    }
)

export default service
